import { render, staticRenderFns } from "./questionFish.vue?vue&type=template&id=44c7d672&scoped=true&"
import script from "./questionFish.vue?vue&type=script&lang=js&"
export * from "./questionFish.vue?vue&type=script&lang=js&"
import style0 from "./questionFish.vue?vue&type=style&index=0&id=44c7d672&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7d672",
  null
  
)

export default component.exports